<template>
    <span class="text-brand-red text-sm"><slot /></span>
</template>

<script setup></script>
